export default __webpack_public_path__ + "static/media/avatar-generic.ca367c76.svg";